(function () {
  'use strict';

  var STORAGE_KEY = 'gizet_wishlist_v1';
  var config = window.GizetWishlistConfig || {};

  function read() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      return stored.filter(function (handle, index, list) {
        return typeof handle === 'string' && handle.length > 0 && list.indexOf(handle) === index;
      });
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      return;
    }
    sync();
    document.dispatchEvent(new CustomEvent('gizet:wishlist-change', { detail: { handles: handles.slice() } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var handles = read();
    if (handles.indexOf(handle) === -1) handles.unshift(handle);
    write(handles);
  }

  function remove(handle) {
    write(read().filter(function (savedHandle) { return savedHandle !== handle; }));
  }

  function toggle(handle) {
    if (!handle) return false;
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  function sync() {
    var handles = read();
    var count = handles.length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count === 0;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var saved = handles.indexOf(button.getAttribute('data-wishlist-handle')) !== -1;
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? 'ከተወዳጅ ያስወግዱ' : 'ወደ ተወዳጅ ጨምር';
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeImage(url) {
    if (!url) return '';
    return String(url).indexOf('//') === 0 ? 'https:' + url : String(url);
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    var symbol = config.currencySymbol || 'Br';
    return symbol + value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function productCard(product) {
    var handle = escapeHtml(product.handle);
    var url = '/products/' + encodeURIComponent(product.handle);
    var image = normalizeImage(product.featured_image || (product.images && product.images[0]) || '');
    var imageMarkup = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '<div class="gizet-wishlist-card__placeholder">G</div>';

    return '<article class="gizet-wishlist-card" data-wishlist-card="' + handle + '">' +
      '<a class="gizet-wishlist-card__image" href="' + url + '">' + imageMarkup + '</a>' +
      '<div class="gizet-wishlist-card__body">' +
        (product.vendor ? '<p>' + escapeHtml(product.vendor) + '</p>' : '') +
        '<h2><a href="' + url + '">' + escapeHtml(product.title) + '</a></h2>' +
        '<strong>' + formatMoney(product.price) + '</strong>' +
        '<div class="gizet-wishlist-card__actions">' +
          '<a href="' + url + '">ምርቱን ይመልከቱ</a>' +
          '<button type="button" data-wishlist-remove="' + handle + '">አስወግድ</button>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function renderWishlistPage() {
    var grid = document.getElementById('GizetWishlistGrid');
    if (!grid) return;

    var empty = document.getElementById('GizetWishlistEmpty');
    var loading = document.getElementById('GizetWishlistLoading');
    var handles = read();

    if (!handles.length) {
      grid.innerHTML = '';
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        })
        .catch(function () { return null; });
    })).then(function (products) {
      var validProducts = products.filter(Boolean);
      var validHandles = validProducts.map(function (product) { return product.handle; });

      if (validHandles.length !== handles.length) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(validHandles)); } catch (error) {}
      }

      grid.innerHTML = validProducts.map(productCard).join('');
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = validProducts.length > 0;
      sync();
    });
  }

  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton.getAttribute('data-wishlist-handle'));
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(removeButton.getAttribute('data-wishlist-remove'));
      var card = removeButton.closest('[data-wishlist-card]');
      if (card) card.remove();
      if (!read().length) renderWishlistPage();
    }
  });

  document.addEventListener('gizet:wishlist-change', function () {
    if (document.getElementById('GizetWishlistGrid')) renderWishlistPage();
  });

  window.GizetWishlist = {
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    sync: sync,
    render: renderWishlistPage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync();
      renderWishlistPage();
    });
  } else {
    sync();
    renderWishlistPage();
  }
})();
